import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { class: "title" };
const _hoisted_2 = { class: "list" };
const _hoisted_3 = { style: { "margin-top": "10px" } };
import { keyboardEnum } from '@/constants/global';
import hubStorage from '@/helpers/hubStorage';
import vuexStore from '@/vuex-store';
import { userGetterType } from '@/vuex-store/user/getters';
import { computed, onMounted, ref, watch, } from 'vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'Debugger',
    setup(__props) {
        const isShow = ref(0);
        const userId = computed(() => vuexStore.getters[userGetterType.userId]);
        const userLevelName = computed(() => vuexStore.getters[userGetterType.userLevelName]);
        const userLevel = computed(() => vuexStore.getters[userGetterType.userLevel]);
        const userLevelPlainName = computed(() => vuexStore.getters[userGetterType.userLevelPlainName]);
        const distributorName = computed(() => vuexStore.getters[userGetterType.distributorName]);
        const distributorId = computed(() => vuexStore.getters[userGetterType.distributorId]);
        const hubName = computed(() => vuexStore.getters[userGetterType.hubName]);
        const hubCode = computed(() => vuexStore.getters[userGetterType.hubCode]);
        const isHead = computed(() => vuexStore.getters[userGetterType.isHead]);
        const isPermissionOtherHub = computed(() => vuexStore.getters[userGetterType.isPermissionOtherHub]);
        const getterAllPermission = computed(() => vuexStore.getters[userGetterType.getterAllPermission]);
        isShow.value = Number(hubStorage.getItem('dbg'));
        const handleClickLogout = () => {
            vuexStore.dispatch('user/logout');
        };
        /**
         * 단축키 입력 이벤트 핸들러
         * @param event
         */
        const handleKeyUp = async (event) => {
            const pressedKey = event.which;
            if (event.shiftKey && pressedKey === keyboardEnum.A) {
                isShow.value = Number(!isShow.value);
            }
        };
        const handleClickShow = () => {
            isShow.value = 1;
        };
        const handleClickHide = () => {
            isShow.value = 0;
        };
        watch(() => isShow.value, (value) => {
            hubStorage.setItem({
                key: 'dbg',
                value,
            });
        });
        onMounted(() => {
            window.addEventListener('keyup', handleKeyUp);
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["debugger-pane", isShow.value ? 'on' : 'off'])
            }, [
                _withDirectives(_createElementVNode("div", { onClick: handleClickShow }, [
                    _cache[0] || (_cache[0] = _createTextVNode(" 열기 (shift + a) / ")),
                    _withDirectives(_createElementVNode("span", null, " BE: " + _toDisplayString(_ctx.$brgGlobal.VUE_APP_BACKEND_ENV), 513 /* TEXT, NEED_PATCH */), [
                        [_vShow, _ctx.$brgGlobal.VUE_APP_BACKEND_ENV]
                    ])
                ], 512 /* NEED_PATCH */), [
                    [_vShow, !isShow.value]
                ]),
                _withDirectives(_createElementVNode("div", null, [
                    _createElementVNode("div", {
                        class: "btn-close",
                        onClick: handleClickHide
                    }, " 닫기 (shift + a) "),
                    (_ctx.$route.name === 'Login')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _cache[1] || (_cache[1] = _createElementVNode("span", { class: "title" }, " 🧪 개발환경 ", -1 /* CACHED */)),
                            _createElementVNode("div", _hoisted_1, [
                                _createElementVNode("b", null, "API PROXY TARGET: " + _toDisplayString(_ctx.$brgGlobal.VUE_APP_BACKEND_ENV), 1 /* TEXT */)
                            ])
                        ], 64 /* STABLE_FRAGMENT */))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createElementVNode("div", _hoisted_2, [
                                _createElementVNode("div", null, " Version: " + _toDisplayString(_ctx.$brgGlobal.VUE_APP_VERSION), 1 /* TEXT */),
                                _createElementVNode("div", null, " ENV: " + _toDisplayString(_ctx.$brgGlobal.VUE_APP_ENV), 1 /* TEXT */),
                                _withDirectives(_createElementVNode("div", null, " BACKEND_ENV: " + _toDisplayString(_ctx.$brgGlobal.VUE_APP_BACKEND_ENV), 513 /* TEXT, NEED_PATCH */), [
                                    [_vShow, _ctx.$brgGlobal.VUE_APP_BACKEND_ENV]
                                ]),
                                _createElementVNode("div", null, " userId: " + _toDisplayString(userId.value), 1 /* TEXT */),
                                _createElementVNode("div", null, [
                                    _cache[2] || (_cache[2] = _createTextVNode(" 계정타입: ")),
                                    _createElementVNode("b", null, _toDisplayString(userLevelName.value), 1 /* TEXT */)
                                ]),
                                _createElementVNode("div", null, [
                                    _createTextVNode(" 총판: " + _toDisplayString(distributorName.value) + " (", 1 /* TEXT */),
                                    _createElementVNode("b", null, _toDisplayString(distributorId.value), 1 /* TEXT */),
                                    _cache[3] || (_cache[3] = _createTextVNode(") "))
                                ]),
                                _createElementVNode("div", null, [
                                    _createTextVNode(" 허브: " + _toDisplayString(hubName.value) + " (", 1 /* TEXT */),
                                    _createElementVNode("b", null, _toDisplayString(hubCode.value), 1 /* TEXT */),
                                    _cache[4] || (_cache[4] = _createTextVNode(") "))
                                ]),
                                _createElementVNode("div", null, [
                                    _cache[5] || (_cache[5] = _createTextVNode(" 대표허브 여부: ")),
                                    _createElementVNode("b", null, _toDisplayString(isHead.value), 1 /* TEXT */)
                                ]),
                                _createElementVNode("div", null, [
                                    _cache[6] || (_cache[6] = _createTextVNode(" 타허브 선택 권한 여부: ")),
                                    _createElementVNode("b", null, _toDisplayString(isPermissionOtherHub.value), 1 /* TEXT */)
                                ]),
                                _createElementVNode("div", null, " lv: " + _toDisplayString(userLevel.value) + " / name: " + _toDisplayString(userLevelPlainName.value), 1 /* TEXT */)
                            ]),
                            _createElementVNode("div", _hoisted_3, [
                                _cache[7] || (_cache[7] = _createElementVNode("div", null, " 유저 권한 ", -1 /* CACHED */)),
                                _createElementVNode("ul", null, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getterAllPermission.value, (value, key) => {
                                        return (_openBlock(), _createElementBlock("li", { key: key }, _toDisplayString(key) + ": " + _toDisplayString(value), 1 /* TEXT */));
                                    }), 128 /* KEYED_FRAGMENT */))
                                ])
                            ]),
                            _cache[8] || (_cache[8] = _createElementVNode("hr", null, null, -1 /* CACHED */)),
                            _createElementVNode("div", { class: "btn" }, [
                                _createElementVNode("button", { onClick: handleClickLogout }, " 로그아웃 ")
                            ])
                        ], 64 /* STABLE_FRAGMENT */))
                ], 512 /* NEED_PATCH */), [
                    [_vShow, isShow.value]
                ])
            ], 2 /* CLASS */));
        };
    }
});
